// extracted by mini-css-extract-plugin
export default {"aboutLabel":"HelperIcon_aboutLabel"};